import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResponseCompanies } from "../incadea-interfaces/responses/ResponseCompanies.interface";
import { RespDeptMakes } from "../incadea-interfaces/responses/ResponseDeptMakes.interface";
import { ResponseTimeSlots } from "../incadea-interfaces/responses/ResponseTimeSlots.interface";
import { requestTimeSlots, serviceObj } from "../incadea-interfaces/requests/RequestTimeSlots.interface";
import { incadeaEnvironment } from "src/environments/environment";
@Injectable({
    providedIn: 'root',
  })
export class GetTimeSlotsService{

  
    constructor(private http: HttpClient,
       ) { 

        }
    public getTimeSlots(token:string,CompanyId:string,LocationId:string,DateFrom:string,DateTo:string, ResourceIds: string[], services:serviceObj[] ,backEndCode:string) {
        const timeSlotsParams:requestTimeSlots = {
       DateFrom,
       DateTo,
       ResourceIds,
       services,

        };
       
        // Define el encabezado de la solicitud
        const headers = new HttpHeaders()
        .set('Accept-Language', 'en-US,en;q=0.9')
        .set('Authorization', `Bearer ${token}`)
        .set('backend-code', `${backEndCode}`);
        const url = new URL(`${incadeaEnvironment.departments}/${CompanyId}/timeslots`)
        url.searchParams.append('LocationId',LocationId)
        // Realiza la solicitud POST
       return this.http.post<ResponseTimeSlots[]>(url.toString(),timeSlotsParams, { headers })
      }
    }
  